import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-dashboard',
	templateUrl: './icon-dashboard.component.svg',
})
export class IconDashboardComponent {}
